import BASE_URL from "../Services/AxiosInstance"

export const API_ENDPOINTS = {
  
  //////////////////////////////////////USER URLS /////////////////////////////////////
  GET_USER_LIST: "/api/Users/getUserList",
  GET_USER_NAME:"/api/Users/getUserName",
  GET_USER_DETAILS:"/api/Users/GetUserRegReport",
  GET_USER_LOG:"/api/Users/GetUserLog", 
  GET_USER_WORKS:"/GetUserInfo",
  UPDATE_USER:"/api/Users/UpdateUser",
  ADD_USER:"/api/Users/add",
  GET_USER_BYID:"/api/Users/getUser",
 GET_USER_REPORT:"/api/Users/GetUserReport",
//   GET_USERTASKS:"/GetTaskInfo",
//   GET_USERPROJECTS:"/GetProjectInfo",
//   GET_USERBUGS:"/GetBugInfo",

GET_USERDETAILS_PAGE:"/UserDetailsPage",
//////////////////////////////////////PROJECT URLS /////////////////////////////////////

  GET_PROJECTS_REPORT: "/api/Projects/GetProjectReport",
  GET_PROJECTS_NAME: "api/Projects/getProjects",
  GET_PROJECTS_BYID:"/api/Projects/GetProjectById",
  POST_PROJECTS:"/api/Projects/add",

//////////////////////////////////////TASK URLS /////////////////////////////////////
GET_TASKS_REPORT: "/api/Tasks/GetTaskReport",
  ADD_TASK: "/api/Tasks/AddTask",

  UPDATE_TASK:"/api/Tasks/updateTask",
  GET_TASKS_BY_USERID: "/GetTaskListById",
  GET_TASKS_BY_PROJECTID: "/GetTaskListById",
  GET_TASKS_BYID: "/GetTask_Id/",


  ///////////////////////////////////// status /////////////////////////////////////
  GET_STATUS: "/status",
  GET_PRIORIIY:"/priority",
  GET_ROLE:"/ROLE",


  GET_BUG_BYID:"/GetBug_Id",
  GET_BUG_LIST:"/api/Bugs/GetBugReport",
  GET_BUG_BY_USERID:"/GetBugListById",
};